(function(angular){
	'use strict';
	
	angular
		.module('revealModule')
		.directive('reveal', [
			'RevealService',
			'$window',
			'STATIC_BASE_PATH',
			revealFunction
		]);
	
	function revealFunction(RevealService, $window, STATIC_BASE_PATH) {
		return {
			restrict: 'A',
			transclude: true,
			templateUrl: STATIC_BASE_PATH + '/static/html/shared/reveal/reveal.html',
			scope: {},
			link: function ($scope, $attrs, $elem) {
				var isInViewport = RevealService.isMiddleOfElementInViewport;
				var element = $elem.$$element[0];

				$scope.revealed = false;

				var setRevealed = function () {
					if (isInViewport(element)) {
						$scope.$apply(function () {
							$scope.revealed = true;
						});
						angular.element($window).off('load resize scroll', setRevealed);
					}
				};

				angular.element($window).on('load resize scroll', setRevealed);
			}
		};
	}
})(window.angular);